import { Gaussian2D } from "./gaussian2D/Gaussian2D.js";
/**
 * Generate a instance of a specific kind of shape.
 * @param shape - shape descriptor specifying the kind and parameters.
 * @returns an instance of the requested 2D shape class.
 */
export function getShape2D(shape) {
    const { kind } = shape;
    switch (kind) {
        case 'gaussian':
            return new Gaussian2D(shape);
        default: {
            const unHandled = kind;
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            throw new Error(`Unknown distribution ${unHandled}`);
        }
    }
}
//# sourceMappingURL=getShape2D.js.map